import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeContext } from './ThemeContext';
import { zeefiTheme } from '../themes';

const themeMap = {
  zeefiTheme
};
const StyledComponentThemeProvider = ({
  children
}: React.PropsWithChildren) => {
  const { theme } = React.useContext(ThemeContext);
  return <ThemeProvider theme={themeMap[theme]}>{children}</ThemeProvider>;
};
export { StyledComponentThemeProvider };
